import React from "react";
import "../components/Styles/LegalAgreement.css";
import {
  FaFileSignature,
  FaUserShield,
  FaBriefcase,
  FaHandshake,
  FaUniversity,
  FaGavel,
  FaCheckCircle,
} from "react-icons/fa";

function LegalAgreement() {
  const agreementData = [
    {
      title: "Employment Agreement",
      price: "₹2999",
      oldPrice: "₹6999",
      icon: <FaBriefcase />,
      description:
        "Professional employee contracts drafted with legal compliance and HR protection.",
      points: [
        "Employee roles & responsibilities",
        "Salary & benefits clauses",
        "Termination conditions",
        "Confidentiality protection",
      ],
    },
    {
      title: "Non Disclosure Agreement",
      price: "₹2499",
      oldPrice: "₹5999",
      icon: <FaUserShield />,
      description:
        "Protect your confidential business information with professionally drafted NDA.",
      points: [
        "Protect sensitive information",
        "Secure business data",
        "Custom confidentiality clauses",
        "Legally enforceable drafting",
      ],
    },
    {
      title: "Partnership Agreement",
      price: "₹4999",
      oldPrice: "₹10999",
      icon: <FaHandshake />,
      description:
        "Clearly define business partnership terms and ownership rights.",
      points: [
        "Profit & loss sharing",
        "Partner responsibilities",
        "Business ownership clarity",
        "Dispute resolution clauses",
      ],
    },
    {
      title: "Rental Agreement",
      price: "₹1999",
      oldPrice: "₹4999",
      icon: <FaUniversity />,
      description:
        "Get legally verified rental agreements for residential and commercial property.",
      points: [
        "Tenant & owner protection",
        "Property usage terms",
        "Security deposit clauses",
        "Easy registration support",
      ],
    },
    {
      title: "Service Agreement",
      price: "₹3499",
      oldPrice: "₹7999",
      icon: <FaFileSignature />,
      description:
        "Professional agreements for service providers and clients.",
      points: [
        "Service deliverables",
        "Payment terms",
        "Timeline & obligations",
        "Legal dispute protection",
      ],
    },
    {
      title: "Vendor Agreement",
      price: "₹3999",
      oldPrice: "₹8999",
      icon: <FaGavel />,
      description:
        "Secure vendor relationships with custom legal agreements.",
      points: [
        "Vendor obligations",
        "Payment protection",
        "Delivery conditions",
        "Business risk reduction",
      ],
    },
  ];

  return (
    <div className="legal-agreement-page">

      {/* ================= HERO ================= */}

      <section className="agreement-hero">
        <div className="container">

          <div className="agreement-hero-content">

            <span className="agreement-tag">
              Professional Agreement Drafting
            </span>

            <h1>
              Secure Your Business <br />
              With Legal Agreements
            </h1>

            <p>
              Get legally verified agreements drafted by experienced
              corporate lawyers for business, employment, rental,
              vendor, partnership, and service protection.
            </p>

            <button className="agreement-main-btn">
              Get Started
            </button>

          </div>

        </div>
      </section>

      {/* ================= AGREEMENT SERVICES ================= */}

      <section className="agreement-services">
        <div className="container">

          <div className="agreement-heading">
            <h2>Our Legal Agreement Services</h2>

            <p>
              Professionally drafted agreements for startups,
              businesses, employers, landlords, and entrepreneurs.
            </p>
          </div>

          <div className="agreement-grid">

            {agreementData.map((item, index) => (
              <div className="agreement-service-card" key={index}>

                <div className="agreement-icon">
                  {item.icon}
                </div>

                <h3>{item.title}</h3>

                <p className="agreement-desc">
                  {item.description}
                </p>

                <div className="agreement-price-box">
                  <span className="agreement-price">
                    {item.price}
                  </span>

                  <span className="agreement-old-price">
                    {item.oldPrice}
                  </span>
                </div>

                <ul>
                  {item.points.map((point, i) => (
                    <li key={i}>
                      <FaCheckCircle /> {point}
                    </li>
                  ))}
                </ul>

                <button className="agreement-btn">
                  Know More
                </button>

              </div>
            ))}

          </div>

        </div>
      </section>

      {/* ================= WHY SECTION ================= */}

      <section className="legal-benefits">
        <div className="container">

          <div className="agreement-heading">
            <h2>Why Legal Agreements Matter?</h2>
          </div>

          <div className="benefits-grid">

            <div className="benefit-card">
              <h3>Legal Protection</h3>

              <p>
                Protect your business and personal interests
                from future disputes and misunderstandings.
              </p>
            </div>

            <div className="benefit-card">
              <h3>Clear Responsibilities</h3>

              <p>
                Define roles, obligations, and payment terms
                clearly for all parties involved.
              </p>
            </div>

            <div className="benefit-card">
              <h3>Business Security</h3>

              <p>
                Reduce legal risks with professionally
                structured and legally compliant agreements.
              </p>
            </div>

            <div className="benefit-card">
              <h3>Custom Drafting</h3>

              <p>
                Tailor-made legal agreements according
                to your business requirements.
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* ================= PROCESS ================= */}

      <section className="agreement-process">
        <div className="container">

          <div className="agreement-heading">
            <h2>How Our Process Works?</h2>
          </div>

          <div className="process-wrapper">

            <div className="process-card">
              <span>01</span>
              <h3>Requirement Discussion</h3>
              <p>
                Discuss your legal agreement requirements with our experts.
              </p>
            </div>

            <div className="process-card">
              <span>02</span>
              <h3>Professional Drafting</h3>
              <p>
                Senior lawyers draft your agreement professionally.
              </p>
            </div>

            <div className="process-card">
              <span>03</span>
              <h3>Review & Changes</h3>
              <p>
                Review your document and request modifications if needed.
              </p>
            </div>

            <div className="process-card">
              <span>04</span>
              <h3>Final Delivery</h3>
              <p>
                Get your final legally verified agreement quickly.
              </p>
            </div>

          </div>

        </div>
      </section>

    </div>
  );
}

export default LegalAgreement;